module.exports = __webpack_public_path__ + "img/cogwheel.5e1279e1.jpg";